import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface Region {
  id: number;
  name: string;
}

export interface Department {
  id: number;
  name: string;
  regionId: number;
  region: Region;
}

export interface Locality {
  id: number;
  name: string;
  departmentId: number;
  department: Department;
}

const fetchLocalities = async (): Promise<Locality[]> => {
  try {
    const { data } = await api.get<Locality[]>('/api/localities');
    return data;
  } catch (error) {
    throw new Error('Error al cargar las localidades');
  }
};

export const useLocalities = (selectedLocalityId?: number) => {
  const { data: localities = [] } = useQuery({
    queryKey: ['localities'],
    queryFn: fetchLocalities,
  });

  const selectedLocality = localities.find(locality => locality.id === selectedLocalityId);
  const region = selectedLocality?.department.region.name || '';
  const department = selectedLocality?.department.name || '';

  return {
    localities,
    region,
    department,
  };
}; 